import React, { Suspense } from 'react';
import { AllEnterPrisesRoutes } from '.';
import Loader from '../../components/loader';
import { Route, Routes } from 'react-router-dom';

const EnterPrisesRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {AllEnterPrisesRoutes?.map((item, index) => {
          return (
            <Route key={index} exact path={item.path} element={item?.element} />
          );
        })}
      </Routes>
    </Suspense>
  )
};

export default EnterPrisesRoutes;